export default "__VITE_ASSET__8WWXBsqX__"